<template>
  <div class="tab-btn label-content">
    <div class="header" style="margin-bottom: 10px">
      <el-button type="primary" size="mini" @click="handleImport"
        >导入数据</el-button
      >
    </div>
    <div class="content">
      <SimpleTable
        :showIndex="false"
        table-code="importQuota"
        :loading="loading"
        :columns="columns"
        :data="tableData"
      />
    </div>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, selectFile } from '@/utils/index'

export default {
  name: 'ImportQuota',
  inject: ['detailsVm'],
  components: {
    SimpleTable
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      columns: [
        { field: 'code', title: '编码' },
        { field: 'type', title: '类别' },
        { field: 'type', title: '名称' },
        { field: 'spec', title: '规格型号' },
        { field: 'unit', title: '单位' },
        { field: 'content', title: '含量' }
      ]
    }
  },
  watch: {
    basicInfo: {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      if (!this.basicInfo?.id) return
      this.getTableData()
    },

    async getTableData() {
      this.loading = true
      const res = await this.$service.get(
        '/quota-library/import-quota-details',
        { quotaLibraryId: this.basicInfo.id }
      )
      this.tableData = sortRecords(res.data || [])
      this.loading = false
    },
    async handleImport() {
      try {
        const file = await selectFile({
          accept: '.xlsx,.xls',
          multiple: false
        })
        if (file) this.uploadFile(file)
      } catch (error) {
        console.error('文件选择失败:', error)
      }
    },
    async uploadFile(file) {
      this.detailsVm.loading = true
      const formData = new FormData()
      formData.append('quotaLibraryId', this.basicInfo.id)
      formData.append('file', file)
      const res = await this.$service.post(
        '/quota-library/import-quota-detail',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      )
      if (res.code === 200) {
        this.$message.success('导入成功')
        this.getTableData()
      }
      this.detailsVm.loading = false
    }
  }
}
</script>

<style scoped lang="less">
.label-content {
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .content {
    width: 100%;
    flex: 1;
  }
}
</style>
